import { DateInputRange } from '@ui/src';
import { useAppDispatch } from '@store';
import { getValueById } from '../../hoc/dashboard/store/slice';
import TransactionsTypePicker from './transations-type-picker';
import PeriodPicker from './period-picker';
import {
  Period,
  // ViewMode,
} from '../../hoc/dashboard/types';
import { DashboardValuesControlsTypes } from './types';

import cn from './dashboard.module.css';

const DashboardValuesControls = ({
  // viewMode,
  withTransactionsType,
  transactionsType,
  setTransactionsType,
  period,
  setPeriod,
  setSelectedDate,
  selectedDate,
  pickerPosition,
}: // getValues,
DashboardValuesControlsTypes) => {
  // let controlsContent;

  const dispatch = useAppDispatch();

  // if (viewMode === ViewMode.CHARTS) {
  //   controlsContent = (
  //     <>
  //       {withTransactionsType && (
  //         <>
  //           <button
  //             type="button"
  //             className={`${cn.dashboardValuesControlsButton} ${
  //               transactionsType === TransactionsType.INCOMING
  //                 ? cn.dashboardValuesControlsButtonActive
  //                 : ''
  //             }`}
  //             onClick={() => {
  //               if (setTransactionsType) {
  //                 setTransactionsType(TransactionsType.INCOMING);
  //               }

  //               getValues();

  //               dispatch(
  //                 getValueById({
  //                   transactionsType,
  //                   period,
  //                   dates: selectedDate,
  //                 }),
  //               );
  //             }}
  //           >
  //             Incoming
  //           </button>
  //           <button
  //             type="button"
  //             className={`${cn.dashboardValuesControlsButton} ${
  //               transactionsType === TransactionsType.OUTGOING
  //                 ? cn.dashboardValuesControlsButtonActive
  //                 : ''
  //             }`}
  //             onClick={() => {
  //               if (setTransactionsType) {
  //                 setTransactionsType(TransactionsType.OUTGOING);
  //               }

  //               getValues();

  //               dispatch(
  //                 getValueById({
  //                   transactionsType,
  //                   period,
  //                   dates: selectedDate,
  //                 }),
  //               );
  //             }}
  //           >
  //             Outgoing
  //           </button>
  //           <div className={cn.dashboardValuesControlsSeparator} />
  //         </>
  //       )}
  //       <button
  //         type="button"
  //         className={`${cn.dashboardValuesControlsButton} ${
  //           period === Period.TODAY
  //             ? cn.dashboardValuesControlsButtonActive
  //             : ''
  //         }`}
  //         onClick={() => {
  //           setPeriod(Period.TODAY);
  //           getValues();

  //           dispatch(
  //             getValueById({
  //               transactionsType,
  //               period: Period.TODAY,
  //               dates: [],
  //             }),
  //           );
  //         }}
  //       >
  //         Today
  //       </button>
  //       <button
  //         type="button"
  //         className={`${cn.dashboardValuesControlsButton} ${
  //           period === Period.YESTERDAY
  //             ? cn.dashboardValuesControlsButtonActive
  //             : ''
  //         }`}
  //         onClick={() => {
  //           setPeriod(Period.YESTERDAY);
  //           getValues();

  //           dispatch(
  //             getValueById({
  //               transactionsType,
  //               period: Period.YESTERDAY,
  //               dates: [],
  //             }),
  //           );
  //         }}
  //       >
  //         Yesterday
  //       </button>
  //       <button
  //         type="button"
  //         className={`${cn.dashboardValuesControlsButton} ${
  //           period === Period.WEEK ? cn.dashboardValuesControlsButtonActive : ''
  //         }`}
  //         onClick={() => {
  //           setPeriod(Period.WEEK);
  //           getValues();

  //           dispatch(
  //             getValueById({
  //               transactionsType,
  //               period: Period.WEEK,
  //               dates: [],
  //             }),
  //           );
  //         }}
  //       >
  //         Week
  //       </button>
  //       <button
  //         type="button"
  //         className={`${cn.dashboardValuesControlsButton} ${
  //           period === Period.MONTH
  //             ? cn.dashboardValuesControlsButtonActive
  //             : ''
  //         }`}
  //         onClick={() => {
  //           setPeriod(Period.MONTH);
  //           getValues();

  //           dispatch(
  //             getValueById({
  //               transactionsType,
  //               period: Period.MONTH,
  //               dates: [],
  //             }),
  //           );
  //         }}
  //       >
  //         Month
  //       </button>
  //       <button
  //         type="button"
  //         className={`${cn.dashboardValuesControlsButton} ${
  //           period === Period.QUARTER
  //             ? cn.dashboardValuesControlsButtonActive
  //             : ''
  //         }`}
  //         onClick={() => {
  //           setPeriod(Period.QUARTER);
  //           getValues();

  //           dispatch(
  //             getValueById({
  //               transactionsType,
  //               period: Period.QUARTER,
  //               dates: [],
  //             }),
  //           );
  //         }}
  //       >
  //         Quarter
  //       </button>
  //     </>
  //   );
  // } else {
  //   controlsContent = (
  //     <>
  //       {withTransactionsType && (
  //         <>
  //           <TransactionsTypePicker
  //             transactionsType={transactionsType}
  //             setTransactionsType={(type) => {
  //               if (setTransactionsType) {
  //                 setTransactionsType(type);
  //               }

  //               dispatch(
  //                 getValueById({
  //                   transactionsType: type,
  //                   period,
  //                   dates: [],
  //                 }),
  //               );
  //             }}
  //             getValues={getValues}
  //           />
  //           <div className={cn.dashboardValuesControlsSeparator} />
  //         </>
  //       )}
  //       <PeriodPicker
  //         period={period}
  //         setPeriod={(nextPeriod) => {
  //           setPeriod(nextPeriod);

  //           dispatch(
  //             getValueById({
  //               transactionsType,
  //               period: nextPeriod,
  //               dates: [],
  //             }),
  //           );
  //         }}
  //         getValues={getValues}
  //       />
  //     </>
  //   );
  // }

  const controlsContent = (
    <>
      {withTransactionsType && (
        <>
          <TransactionsTypePicker
            transactionsType={transactionsType}
            setTransactionsType={(type) => {
              if (setTransactionsType) {
                setTransactionsType(type);
              }

              dispatch(
                getValueById({
                  transactionsType: type,
                  period,
                  dates: [],
                }),
              );
            }}
          />
          <div className={cn.dashboardValuesControlsSeparator} />
        </>
      )}
      <PeriodPicker
        period={period}
        setPeriod={(nextPeriod) => {
          setPeriod(nextPeriod);

          dispatch(
            getValueById({
              transactionsType,
              period: nextPeriod,
              dates: [],
            }),
          );
        }}
      />
    </>
  );

  return (
    <div className={cn.dashboardValuesControls}>
      <div className={cn.dashboardValuesControlsLeft}>{controlsContent}</div>
      <div
        // viewMode === ViewMode.GRID ? cn.dashboardValuesControlsRightGrid : ''
        className={`${cn.dashboardValuesControlsRight} ${cn.dashboardValuesControlsRightGrid}`}
      >
        <DateInputRange
          onChangeRange={(dates) => {
            if (dates?.length) {
              setPeriod(undefined);
            }
            setSelectedDate(dates.map((item) => item.toISOString()));

            dispatch(
              getValueById({
                transactionsType,
                dates: dates.map((item) => item.toISOString()),
              }),
            );
          }}
          placeholder="Custom period"
          values={selectedDate}
          pickerPisition={pickerPosition}
          className={`${
            !selectedDate.length ? cn.dashboardValuesPeriodPickerEmpty : ''
          } ${cn.dashboardValuesPeriodPicker}`}
          onReset={() => {
            setSelectedDate([]);
            setPeriod(Period.TODAY);

            dispatch(
              getValueById({
                transactionsType,
                period,
                dates: [],
              }),
            );
          }}
        />
      </div>
    </div>
  );
};

export default DashboardValuesControls;
